<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mb-4" />
        <div class="card-outlined p-4">
          <h1 class="text-subtitle-underline">{{ t('account.change_password.title') }}</h1>
          <form @submit.prevent="onSubmit">
            <div class="mb-4">
              <label
                for="password_current"
                class="form-label"
              >
                {{ t('word.password_current') }}
              </label>
              <input
                v-model="password_current"
                id="password_current"
                name="password_current"
                type="password"
                :placeholder="t('word.password_current')"
                :class="`form-input mb-1 ${errors['password_current'] ? 'border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['password_current'] }}</p>
            </div>
            <div class="mb-4">
              <label
                for="password"
                class="form-label"
              >
                {{ t('word.password') }}
              </label>
              <input
                v-model="password"
                id="password"
                name="password"
                type="password"
                :placeholder="t('word.password')"
                :class="`form-input mb-1 ${errors['password'] ? 'border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['password'] }}</p>
            </div>
            <div class="mb-4">
              <label
                for="password_confirmation"
                class="form-label"
              >
                {{ t('word.password_confirmation') }}
              </label>
              <input
                v-model="password_confirmation"
                id="password_confirmation"
                name="password_confirmation"
                type="password"
                :placeholder="t('word.password_confirmation')"
                :class="`form-input mb-1 ${errors['password_confirmation'] ? 'border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['password_confirmation'] }}</p>
            </div>
            <div class="flex items-center pt-2">
              <base-form-submit :disabled="btnDisabled" :text="t('word.change')" />
            </div>
          </form>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { axios } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseFormSubmit,
    BaseAlert
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)

    const schema = yup.object({
      password_current: yup.string().required().min(8).max(255),
      password: yup.string().required().min(8).max(255),
      password_confirmation: yup.string().required().min(8).oneOf([yup.ref('password'), null], t('validation.password_confirmation')),
    })
    const { handleSubmit, errors } = useForm({ validationSchema: schema })
    const { value: password_current } = useField('password_current')
    const { value: password } = useField('password')
    const { value: password_confirmation } = useField('password_confirmation')
    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-password', {
          password_current: values.password_current,
          password: values.password,
        })
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('account.change_password.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      password_current,
      password,
      password_confirmation,
      onSubmit,
      btnDisabled
    }
  }
})
</script>
